require('./base.js');
require('../../utils/ajax.js');
require('../../utils/cookies.js');
require('../../utils/localstorage.js');
require('./userstatus.js');
require('./searchbox.js');
require('./bloomreach.js');
require('./ensightenAnalytics.js');
require('./analytics.js');
require('./predictivesearch.js');
require('./searchHistory.js');



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/universalHeader.js
// module id = 317
// module chunks = 4